import { AdminContainer } from '@modules/admin/containers/admin_container';
import { Admin } from '@modules/admin/views/admin_view';
import { useCallback } from 'react';
import { toast } from 'sonner';

export function AdminScreen() {
  const onNotifyLoading = useCallback((message: string) => {
    toast.loading(message);
  }, []);

  const onNotifySuccess = useCallback((message: string) => {
    toast.success(message);
  }, []);

  const onNotifyError = useCallback((message: string) => {
    toast.error(message);
  }, []);

  return (
    <AdminContainer
      View={Admin}
      onNotifyLoading={onNotifyLoading}
      onNotifySuccess={onNotifySuccess}
      onNotifyError={onNotifyError}
    />
  );
}
